import React, { useContext } from 'react';
import { TranslatorContext } from '../../context/Translator';
import { Dropdown, Badge } from 'react-bootstrap';
import { Trophy, Award } from 'react-bootstrap-icons';
import { TrendingDown, TrendingUp, AlertCircle } from 'lucide-react';

export default function ReportCardComponent({
  title,
  data = [],
  valueKey = 'count',
  icon = 'trophy',
  variant = 'primary',
  loading = false,
  onSetValue, // optional: callback khi bấm nút set bên cạnh điểm
}) {
  const { t, n } = useContext(TranslatorContext);

  const getIcon = () => {
    switch (icon) {
      case 'trophy':
        return <Trophy className="me-2" />;
      case 'award':
        return <Award className="me-2" />;
      case 'trending-up':
        return <TrendingUp className="me-2" />;
      case 'trending-down':
        return <TrendingDown className="me-2" />;
      case 'alert':
        return <AlertCircle className="me-2" />;
      default:
        return <Trophy className="me-2" />;
    }
  };

  const getBadgeVariant = (index) => {
    if (index === 0) return 'success';
    if (index === 1) return 'info';
    if (index === 2) return 'warning';
    return 'secondary';
  };

  return (
    <div className="mc-card">
      <div className="mc-card-header">
        <h4 className="mc-card-title">
          {getIcon()}
          {t(title)}
        </h4>
        <Dropdown bsPrefix="mc-dropdown">
          <Dropdown.Toggle bsPrefix="mc-dropdown-toggle">
            <i className="material-icons">more_horiz</i>
          </Dropdown.Toggle>
          <Dropdown.Menu
            align="end"
            className="mc-dropdown-paper"
          >
            <button
              type="button"
              className="mc-dropdown-menu"
            >
              <i className="material-icons">refresh</i>
              <span>{t('refresh')}</span>
            </button>
            <button
              type="button"
              className="mc-dropdown-menu"
            >
              <i className="material-icons">download</i>
              <span>{t('download')}</span>
            </button>
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <div className="mc-card-body">
        {loading ? (
          <div className="text-center p-4">
            <div
              className="spinner-border text-primary"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : data.length === 0 ? (
          <div className="text-center p-4 text-muted">
            <p>Không có dữ liệu</p>
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th style={{ width: '50px' }}>#</th>
                  <th>Tên nhân viên</th>
                  <th>Chi nhánh</th>
                  <th className="text-end">Giá trị</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={item.employee_id || index}>
                    <td>
                      <Badge bg={getBadgeVariant(index)}>{index + 1}</Badge>
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        <div className="mc-avatar">
                          
                        </div>
                        <div className="ms-2">
                          <strong>{item.name}</strong>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span className="text-muted">{item.branch || 'N/A'}</span>
                    </td>
                    <td className="text-end">
                      <div className="d-inline-flex align-items-center gap-2">
                        <strong className={`text-${variant}`}>
                          {typeof item[valueKey] === 'number' ? n(item[valueKey]) : item[valueKey]}
                        </strong>
                        {onSetValue && (
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary px-1 py-0"
                            onClick={() => onSetValue(item)}
                            title="Set điểm"
                          >
                            set
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
